import { isRouteErrorResponse, useRouteError } from 'react-router';

import { Button, LinkButton } from '@/components/Button';
import { buttonClass } from '@/components/buttonClass';
import { EmptyState, Panel } from '@/components/primitives';

export function NotFoundPage() {
  return (
    <Panel className="mx-auto w-full max-w-[520px]" bodyClassName="p-0">
      <EmptyState
        title="Nothing at this address"
        action={
          <LinkButton to="/" variant="primary">
            Overview
          </LinkButton>
        }
      />
    </Panel>
  );
}

export function RouteErrorPage() {
  const error = useRouteError();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'Unknown error.';
  return (
    <div className="min-h-dvh flex items-center justify-center bg-bg text-ink p-6">
      <div className="max-w-[520px] w-full rounded-lg border border-line bg-surface p-6">
        <h1 className="text-heading font-medium">Something went wrong</h1>
        <p className="mt-2 text-body text-ink-2 break-words">{message}</p>
        <div className="mt-4 flex gap-2">
          <Button variant="primary" onClick={() => window.location.reload()}>
            Reload
          </Button>
          {/* A plain anchor: the router may be what failed, so this is a full reload of the overview. */}
          <a href="/" className={buttonClass('secondary', 'md', 'no-underline hover:no-underline')}>
            Overview
          </a>
        </div>
      </div>
    </div>
  );
}
